import * as UserProjectsModule from './index';
 
export const User_AllPaymentsInProject = {
  path: '/dashboard/jobs/allpaymentsinproject',
  name: 'AllPaymentsInProject',
  component: UserProjectsModule.AllPaymentsInProject,
};

export const User_AppliableProjects = {
  path: '/dashboard/jobs/appliableprojects',
  name: 'AppliableProjects',
  component: UserProjectsModule.AppliableProjects,
};

export const User_CancelledProjects = {
  path: '/dashboard/jobs/cancelledprojects',
  name: 'CancelledProjects',
  component: UserProjectsModule.CancelledProjects,
};

export const User_DraftProjects = {
  path: '/dashboard/jobs/draftprojects',
  name: 'DraftProjects',
  component: UserProjectsModule.DraftProjects,
};

export const User_ProjectMedia = {
  path: '/dashboard/jobs/projectmedia',
  name: 'ProjectMedia',
  component: UserProjectsModule.ProjectMedia,
};

export const User_RunningProjects = {
  path: '/dashboard/jobs/runningprojects',
  name: 'RunningProjects',
  component: UserProjectsModule.RunningProjects,
};

export const User_CompletedProjects = {
  path: '/dashboard/jobs/completedprojects',
  name: 'RunningProjects',
  component: UserProjectsModule.CompletedProjects,
};

export const User_UsersAssignedtoProject = {
  path: '/dashboard/jobs/usersassignedtoproject',
  name: 'UsersAssignedtoProject',
  component: UserProjectsModule.UsersAssignedtoProject,
};

export const User_CreateProject = {
  path: '/dashboard/jobs/postnewjob',
  name: 'CreateProject',
  component: UserProjectsModule.CreateProject,
};

export const User_VerifyTransaction = {
  path: '/verifytransaction',
  name: 'VerifyTransaction',
  component: UserProjectsModule.VerifyTransaction,
};

export const User_ShowProject = {
  path: '/dashboard/jobs/showproject/:id',
  name: 'ShowProject',
  component: UserProjectsModule.ShowProject,
};

export const User_PublishedProjects = {
  path: '/dashboard/jobs/publishedjobs',
  name: 'ShowProject',
  component: UserProjectsModule.PublishedProjects,
};

export const User_AllProjects = {
  path: '/dashboard/jobs/allmyjobs',
  name: 'AllMyJobs',
  component: UserProjectsModule.AllProjects,
};

export const User_ViewProject = {
  path: '/dashboard/jobs/viewproject/:id',
  name: 'ShowProject',
  component: UserProjectsModule.ViewProject,
};
